<nz-form-item nz-row nzAlign="middle" nzGutter="5" [style.marginBottom.px]="0">
  <span nz-col>
    <nz-form-label [nzRequired]="isRequired()">
      {{ label() | translate }}
    </nz-form-label>
  </span>

  @let flex = inputWidth() === '100%' ? '1' : null;

  <div nz-col [nzFlex]="flex" [style.width]="inputWidth()">
    <nz-form-control>
      @if (isNumber()) {
        <nz-input-number
          [class]="cssClass()"
          [nzStep]="step()"
          [nzMax]="maxValue()"
          [nzMin]="minValue()"
          [nzPlaceHolder]="label() | translate"
          [ngModel]="value ?? null"
          [nzDisabled]="disabled"
          [nzStatus]="hasErrors() ? 'error' : ''"
          (blur)="onInputTouched()"
          (ngModelChange)="onTextChange($event)"
        />
      } @else {
        <input
          nz-input
          [class]="cssClass()"
          [value]="value ?? null"
          [placeholder]="label() | translate"
          [disabled]="disabled"
          [nzStatus]="hasErrors() ? 'error' : ''"
          (input)="onTextChange($event)"
          (blur)="onInputTouched()"
        />
      }
    </nz-form-control>
  </div>

  @if (suffix()) {
    <span nz-col>{{ suffix() }}</span>
  }
</nz-form-item>

@if (hasErrors()) {
  <div nz-row class="ant-form-item-explain ant-form-item-explain-connected">
    <div nz-col role="alert" class="ant-form-item-explain-error">
      {{ label() | fieldValidationMsg }}
    </div>
  </div>
}
